import { useEffect, useState } from 'react';
import { formatDieValue } from './dice';
import './DamageHitSplat.css';

const DamageHitSplat = ({
  hitId,
  damage,
  critical = false,
  blocked = 0,
  target = 'Enemy',
  incoming = false,
  reduceMotion = false,
}) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 1800);
    return () => clearTimeout(timer);
  }, [hitId]);
  if (!visible || !Number.isFinite(damage) || damage < 0) return null;
  const noDamage = damage === 0;
  const label = noDamage
    ? blocked > 0
      ? 'BLOCKED'
      : 'MISS'
    : critical && !incoming
    ? 'CRITICAL!'
    : null;
  const value = formatDieValue(damage);
  return (
    <div className={`coreboundHitSplatAnchor ${incoming ? 'is-incoming' : ''}`}>
      <div
        key={hitId}
        className={`coreboundHitSplat is-glitch ${
          critical && !noDamage ? 'is-critical' : ''
        } ${noDamage ? 'is-blocked' : ''} ${reduceMotion ? 'is-reduced' : ''} ${
          incoming ? 'is-incoming' : ''
        }`}
        role="status"
        aria-label={`${target}: ${noDamage ? 'no damage' : `${damage} damage`}${
          critical && !noDamage ? ', critical hit' : ''
        }${blocked > 0 ? `, ${blocked} blocked` : ''}`}
      >
        <span className="coreboundHitSplatShockwave" aria-hidden="true" />
        <svg viewBox="0 0 200 132" aria-hidden="true">
          <path
            className="coreboundHitSplatFrame"
            d="M20 14h53l8-8h73l10 10h22v32l8 8v46l-14 14h-53l-8 8H43l-11-10H12V81l-6-7V28Z"
          />
          <path
            className="coreboundHitSplatInner"
            d="M25 23h51l8-8h66l10 10h17v26l8 9v38l-10 9h-51l-8 8H47l-10-10H21V77l-6-6V32Z"
          />
          <path
            className="coreboundHitSplatEdges"
            d="M6 43V28l14-14h29m115 2h22v23m8 46v17l-14 14h-27M12 90v24h20l11 10h25"
          />
          <path
            className="coreboundHitSplatFragments"
            d="M-7 48H8m-2 8h13m163 18h25m-13 7h17M44 2h23m63 128h28"
          />
        </svg>
        <span className="coreboundHitSplatScan" aria-hidden="true" />
        {label && (
          <span className="coreboundHitSplatLabel" aria-hidden="true">
            {label}
          </span>
        )}
        <strong data-value={value} aria-hidden="true">
          {value}
        </strong>
        {blocked > 0 && (
          <span className="coreboundHitSplatCaption" aria-hidden="true">
            {blocked} BLOCKED
          </span>
        )}
      </div>
    </div>
  );
};

export default DamageHitSplat;
